import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const catalogRoutes: RouteObject = {
  path: ROUTES.catalog.root,
  children: [
    {
      index: true,
      lazy: async () => {
        const { CatalogPage } =
          await import('../../../pages/catalog/Catalog.page');

        return { Component: CatalogPage };
      },
    },
    {
      path: ROUTES.catalog.newProduct,
      lazy: async () => {
        const { ProductFormPage } =
          await import('../../../pages/catalog/ProductForm.page');

        return { Component: ProductFormPage };
      },
    },
    {
      path: ROUTES.catalog.generateQRCode,
      lazy: async () => {
        const { QRCodeForLockersPage } =
          await import('../../../pages/catalog/QRCodeForLockers.page');

        return { Component: QRCodeForLockersPage };
      },
    },
  ],
};
